function prependAssets() {
    var head = document.getElementsByTagName('HEAD')[0];
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = window.env.ASSETS;
    head.prepend(link);
}
export default prependAssets;
